import { environment } from '../environments/environment';
export const GlobalVariable = Object.freeze({
  BASE_API_URL: environment.BASE_API_URL,
});
export const dateFormat = 'dd.MM.yyyy';
export const Language = {
  en: 'en-US',
  ru: 'ru-RU',
  kz: 'kk-KZ',
  zh: 'zh-CN',
};
